import asArray from 'utils/arrays/asArray.util';
import logger from 'utils/logger.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';
import { formatDuration } from 'utils/time/time.util';

const L = logger('calculateServicesPriceAndTimeRanges.bl');

// Return the range of prices for a service
export const calculateServicePriceRange = (options) => {
  try {
    const basePrice = options.price ?? 0;

    const servicePrices = asArray(options.role_executions).map((role) => role.price);

    const minPrice = servicePrices.length ? Math.min(basePrice, ...servicePrices) : basePrice;
    const maxPrice = servicePrices.length ? Math.max(basePrice, ...servicePrices) : basePrice;

    return { minPrice, maxPrice };
  } catch (error) {
    L.warn('calculateServicePriceRange()', error);
    return { error };
  }
};

// Return the range of time duration for a service
export const calculateServiceTimeRange = (options) => {
  try {
    const roleDurations = asArray(options?.role_executions).map((role) => role.duration);

    const baseDuration = options?.duration ?? 0;

    let low = baseDuration;
    let high = baseDuration;

    for (const role of roleDurations) {
      if (!role) continue;

      if (role < low) low = role;
      if (role > high) high = role;
    }

    return { low, high, from: low, to: high, duration: baseDuration };
  } catch (error) {
    L.warn('calculateServiceTimeRange()', error);
    return { error };
  }
};

export const formatServiceDuration = (options) => {
  const { from, to, duration } = calculateServiceTimeRange(options) ?? {};

  if (from === to) {
    return formatDuration(duration);
  }

  return `${formatDuration(from)} - ${formatDuration(to)}`;
};

export const fromServicesToFlattened = (services) =>
  asArray(services).reduce((reduced, category) => {
    if (!category || !isFullArray(category.services)) return reduced;

    return [...reduced, ...category.services.map((o) => ({ ...o, color: category.color }))];
  }, []);
